import { useShallow } from 'zustand/react/shallow';
import { useTreeStore } from '../store/TreeStore';
import { useParameterStore } from '../store/ParameterStore';
import { ParameterSubjectType, ParameterType } from '@/types/parameterTypes';
import { Parameter } from '@/backend/models/parameter';
import { useStepIsDisabled } from './useStepIsDisabled';

export const useParameterIsDisabled = (parameter: Parameter): boolean => {
  const operation = useTreeStore((state) => state.operations.find((op) => op.id === parameter.subjectId));
  const containerLookup = useTreeStore((state) => state.containerLookup);

  let stepId = '';

  if (parameter.subjectType === ParameterSubjectType.OPERATION && operation) {
    const scenario = containerLookup[operation.parentId];
    const step = containerLookup[scenario.parentId];
    stepId = step.id;
  } else if (parameter.subjectType === ParameterSubjectType.STEP) {
    stepId = parameter.subjectId;
  }

  const stepInputParameters = useParameterStore(useShallow(state => state.parametersForSubjectAndType(stepId, ParameterType.INPUT)));
  const validationsPassing = useParameterStore(useShallow(state => state.parameterValidationsPassing(stepInputParameters.map(p => p.id))));
  const { disabled: stepIsDisabled } = useStepIsDisabled(stepId);

  if (parameter.viewOnly || parameter.subjectType === ParameterSubjectType.PROCEDURE) {
    return true;
  }

  if (parameter.subjectType === ParameterSubjectType.OPERATION && (operation?.isField() || operation?.isFile())) {
    return true;
  }

  if (!validationsPassing) {
    return false;
  }

  return stepIsDisabled;
};
